// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3gryD","title":"ClientReferral_title__2xVAY","itemText":"ClientReferral_itemText__2UE4x"};